import type { Brands } from '@edreamsodigeo/frontend-core';

interface ColorSet {
  default: string;
  prime: string;
}

interface ColorMap {
  background: ColorSet;
  text: ColorSet;
}

const DEFAULT_COLOR_MAP: ColorMap = {
  background: {
    default: 'primary.50',
    prime: 'primary.90',
  },
  text: {
    default: 'secondary.50',
    prime: 'secondary.50',
  },
};

const CUSTOM_COLOR_MAP: Partial<Record<Brands, ColorMap>> = {
  OP: {
    background: {
      default: 'primary.90',
      prime: 'primary.90',
    },
    text: {
      default: 'primary.50',
      prime: 'primary.50',
    },
  },
  GO: {
    ...DEFAULT_COLOR_MAP,
    text: {
      default: 'primary.30',
      prime: 'primary.30',
    },
  },
};

interface BrandColorProps {
  brand?: Brands;
  isPrimeSite?: boolean;
}

interface BrandColor {
  backgroundColor: string;
  textColor: string;
}

const useBrandColor = ({ brand, isPrimeSite }: BrandColorProps): BrandColor => {
  const type = isPrimeSite ? 'prime' : 'default';
  return {
    backgroundColor:
      (brand && CUSTOM_COLOR_MAP[brand]?.background[type]) ||
      DEFAULT_COLOR_MAP.background[type],
    textColor:
      (brand && CUSTOM_COLOR_MAP[brand]?.text[type]) ||
      DEFAULT_COLOR_MAP.text[type],
  };
};

export default useBrandColor;
